export const SET_DIMENSIONS = 'SET_DIMENSIONS';
export const SET_DIMENSION_POLICY_DATA = 'SET_DIMENSION_POLICY_DATA';
export const UPDATE_DIMENSION_FORM_ERROR = 'UPDATE_DIMENSION_FORM_ERROR';
export const RESET_DIMENSION_POLICY_DATA = 'RESET_DIMENSION_POLICY_DATA';
export const DIMENSION_MEMBERS_DATA = 'DIMENSION_MEMBERS_DATA';
export const SET_HIERARCHIES = 'SET_HIERARCHIES';
export const SET_DIMENSIONS_PAGE_DATA = 'SET_DIMENSIONS_PAGE_DATA';
export const RESET_DIMENSION_MEMBER_DATA = 'RESET_DIMENSION_MEMBER_DATA';
export const PAGINATED_DIMENSION_MEMBERS = 'PAGINATED_DIMENSION_MEMBERS';
export const DIMENSION_ATTRIBUTES = 'DIMENSION_ATTRIBUTES';
export const ADD_DIMENSION_ATTRIBUTE = 'ADD_DIMENSION_ATTRIBUTE';
